import Renderer from './render';
import CanLoad from './canLoad';
import { IRouteTourArguments, ITourControllerProps } from './interface';
import { IBaseController } from '../interface';
import CanRender from './canRender';

const exports: IBaseController<IRouteTourArguments, ITourControllerProps> = {
    renderer: Renderer,
    canRender: CanRender,
    canLoad: CanLoad,
}

export default exports
